/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DetailedMachineInformationOpenReviews model module.
 * @module model/DetailedMachineInformationOpenReviews
 * @version 0.0.1
 */
class DetailedMachineInformationOpenReviews {
    /**
     * Constructs a new <code>DetailedMachineInformationOpenReviews</code>.
     * @alias module:model/DetailedMachineInformationOpenReviews
     */
    constructor() { 
        
        DetailedMachineInformationOpenReviews.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DetailedMachineInformationOpenReviews</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DetailedMachineInformationOpenReviews} obj Optional instance to populate.
     * @return {module:model/DetailedMachineInformationOpenReviews} The populated <code>DetailedMachineInformationOpenReviews</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DetailedMachineInformationOpenReviews();

            if (data.hasOwnProperty('count')) {
                obj['count'] = ApiClient.convertToType(data['count'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DetailedMachineInformationOpenReviews</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DetailedMachineInformationOpenReviews</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} count
 */
DetailedMachineInformationOpenReviews.prototype['count'] = undefined;






export default DetailedMachineInformationOpenReviews;

